import React, { useState } from 'react';
import { Badge } from '../components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { galleryImages } from '../data/mockData';
import { useLanguage } from '../translations/LanguageContext';

const Gallery = () => {
  const { t } = useLanguage();
  const [selectedCategory, setSelectedCategory] = useState('all');

  const filteredImages =
    selectedCategory === 'all'
      ? galleryImages
      : galleryImages.filter((img) => img.category === selectedCategory);

  return (
    <div className="min-h-screen bg-[#2e5453]">
      {/* Hero Section */}
      <section className="bg-[#3d6a68] py-16">
        <div className="container mx-auto px-4 text-center">
          <Badge className="bg-[#96ba1e] text-[#2e5453] hover:bg-[#a8c82e] mb-4">
            {t('nav.gallery')}
          </Badge>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-[#96ba1e]">Magical Moments</h1>
          <p className="text-xl text-[#c4d88f] max-w-3xl mx-auto">
            Take a peek at the joy, laughter, and unforgettable memories we've created together!
          </p>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-16 bg-[#2e5453]">
        <div className="container mx-auto px-4">
          <Tabs defaultValue="all" className="max-w-6xl mx-auto">
            <TabsList className="grid grid-cols-4 w-full max-w-2xl mx-auto mb-12 bg-[#3d6a68]">
              <TabsTrigger 
                value="all" 
                onClick={() => setSelectedCategory('all')}
                className="data-[state=active]:bg-[#96ba1e] data-[state=active]:text-[#2e5453] text-[#c4d88f]"
              >
                All Photos
              </TabsTrigger>
              <TabsTrigger 
                value="parties" 
                onClick={() => setSelectedCategory('parties')}
                className="data-[state=active]:bg-[#96ba1e] data-[state=active]:text-[#2e5453] text-[#c4d88f]"
              >
                Parties
              </TabsTrigger>
              <TabsTrigger 
                value="food" 
                onClick={() => setSelectedCategory('food')}
                className="data-[state=active]:bg-[#96ba1e] data-[state=active]:text-[#2e5453] text-[#c4d88f]"
              >
                Food
              </TabsTrigger>
              <TabsTrigger 
                value="decorations" 
                onClick={() => setSelectedCategory('decorations')}
                className="data-[state=active]:bg-[#96ba1e] data-[state=active]:text-[#2e5453] text-[#c4d88f]"
              >
                Decorations
              </TabsTrigger>
            </TabsList>

            <TabsContent value="all" className="mt-8">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredImages.map((image) => (
                  <div
                    key={image.id}
                    className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all cursor-pointer aspect-square border border-[#96ba1e]"
                  >
                    <img
                      src={image.url}
                      alt={image.alt}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
                      <div className="absolute bottom-4 left-4 right-4">
                        <p className="text-white font-medium">{image.alt}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </TabsContent>

            <TabsContent value="parties" className="mt-8">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredImages.map((image) => (
                  <div
                    key={image.id}
                    className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all cursor-pointer aspect-square border border-[#96ba1e]"
                  >
                    <img
                      src={image.url}
                      alt={image.alt}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
                      <div className="absolute bottom-4 left-4 right-4">
                        <p className="text-white font-medium">{image.alt}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </TabsContent>

            <TabsContent value="food" className="mt-8">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredImages.map((image) => (
                  <div
                    key={image.id}
                    className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all cursor-pointer aspect-square border border-[#96ba1e]"
                  >
                    <img
                      src={image.url}
                      alt={image.alt}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
                      <div className="absolute bottom-4 left-4 right-4">
                        <p className="text-white font-medium">{image.alt}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </TabsContent>

            <TabsContent value="decorations" className="mt-8">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredImages.map((image) => (
                  <div
                    key={image.id}
                    className="group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all cursor-pointer aspect-square border border-[#96ba1e]"
                  >
                    <img
                      src={image.url}
                      alt={image.alt}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
                      <div className="absolute bottom-4 left-4 right-4">
                        <p className="text-white font-medium">{image.alt}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </TabsContent>
          </Tabs>

          {filteredImages.length === 0 && (
            <div className="text-center py-20">
              <p className="text-[#c4d88f] text-lg">No images found in this category.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Gallery;
